var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFillWarning = function SvgFillWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M499.98 83.36c-230 0-416.67 186.67-416.67 416.67S269.98 916.7 499.98 916.7s416.67-186.67 416.67-416.67S729.98 83.36 499.98 83.36Zm0 458.33c-22.92 0-41.67-18.75-41.67-41.67V333.35c0-22.92 18.75-41.67 41.67-41.67s41.67 18.75 41.67 41.67v166.67c0 22.92-18.75 41.67-41.67 41.67Zm41.67 166.67h-83.33v-83.33h83.33v83.33"
  })));
};
export default SvgFillWarning;